// extracted by mini-css-extract-plugin
export default {"wrapper":"WC","content":"XC","firstSection":"YC","text":"ZC","table":"aE","tableText":"bE","row":"cE","column_2":"eE","column_1":"fE","column_3":"gE"};
    if(module.hot) {
      // 1714442369646
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  